import { createFileRoute } from "@tanstack/react-router";
import { sciHead } from "@/lib/science/sci-route";
import { m } from "@/paraglide/messages";
import { CalculatorPage } from "@/tools/gc-content/pages/CalculatorPage";

export const Route = createFileRoute("/gc-content")({
  ssr: true,
  head: () =>
    sciHead({
      basePath: "/gc-content",
      title: m.gc_meta_title(),
      description: m.gc_meta_description(),
      toolName: m.gc_tool_name(),
      faqs: [
        { q: m.gc_faq_q1(), a: m.gc_faq_a1() },
        { q: m.gc_faq_q2(), a: m.gc_faq_a2() },
        { q: m.gc_faq_q3(), a: m.gc_faq_a3() },
        { q: m.gc_faq_q4(), a: m.gc_faq_a4() },
      ],
    }),
  component: CalculatorPage,
});
